/**
* 填写申请页面
* @author PJ
*/
import Cell from 'vux/src/components/cell/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Picker from 'vux/src/components/picker/index.vue'
import Group from 'vux/src/components/group/index.vue'


import { AddressSelect, HeaderBar } from '@/components';

import {
Device,
Log,
encryptPhone,
} from '@/utils';

import { fetchVerificationCode, loginApp, saveFormData } from '@/pages/Application/api';

import config from './config';

const { countList } = config;

export default {
data() {
return {
title: '填写申请',

isSendCode: false,
isShowAddreddPanel: false,
isShowCountPop: false,

setInterval: null,

seconds: 60,

deviceId: Device.getDeviceId(),
provinceId: '',
provinceName: '',

cityId: '',
cityName: '',

districtId: '',
districtName: '',

countText: '',
peopleCount: [],

personNum: '',
companyName: '',
contactName: '',
contactPhone: '',
verificationCode: '',

countList: [countList],
};
},

computed: {
cityNameStr() {
const temp = [];
temp.push(this.provinceName);
temp.push(this.cityName);
temp.push(this.districtName);
return (temp.join(' ')).trim();
},
},

components: {
Group,
Cell,
Popup,
Picker,
AddressSelect,
HeaderBar,
},

methods: {
onStopPropagation(e) {
e.stopPropagation();
},

onBackEvent() {
this.$router.go(-1);
},

onSubmit() {
if (!this.verifyForm()) {
return false;
}
Log('app.takeself.h5_application_detail_apply', {
city: this.cityName,
company_name: this.companyName,
people_count: this.countText,
user_name: this.contactName,
phone_number: encryptPhone(this.contactPhone),
});
this.loginApp();
return true;
},

onOpenAddress() {
this.isShowAddreddPanel = true;
this.$refs.addressPanel.initData({
provinceId: this.provinceId,
cityId: this.cityId,
districtId: this.districtId,
provinceName: this.provinceName,
districtName: this.districtName,
cityName: this.cityName,
});
},

onCloseAddress(data) {

if (data.type === 4) {
this.isShowAddreddPanel = false;
return;
}
this.provinceId = data.provinceId || '';
this.provinceName = data.provinceName || '';
this.cityId = data.cityId || '';
this.cityName = data.cityName || '';
this.districtId = data.districtId || '';
this.districtName = data.districtName || '';
this.isShowAddreddPanel = false;
},

onClickCount() {
this.isShowCountPop = true;
this.peopleCount = [this.countText];
},

onCloseCount() {
this.isShowCountPop = false;
},

onChangeCount(item) {
if (item[0] === '请选择公司常驻人数') {
this.countText = '';
this.personNum = '';
} else {
this.countText = item[0];
this.personNum = countList.indexOf(item[0]) - 1;
}
},

showToast(text, width = '16em') {
this.$vux.toast.show({
position: 'middle',
type: 'text',
width,
text,
});
},

clearInterval() {
this.seconds = 60;
this.isSendCode = false;
if (this.setInterval) {
clearInterval(this.setInterval);
this.setInterval = null;
}
},

countDown() {
this.setInterval = setInterval(() => {
this.seconds = this.seconds - 1;
if (this.seconds <= 0) {
this.clearInterval();
}
}, 1000);
},


verifyForm() {




if (!this.cityId) {
this.showToast('请选择所在城市');
return false;
}
if (this.companyName.trim() === '') {
this.showToast('请输入公司名称');
return false;
}

if (this.companyName.trim().length > 50) {
this.showToast('公司名称最多输入50个字', '18em');
return false;
}

if (this.personNum === '') {
this.showToast('请选择公司常驻人数');
return false;
}

if (!this.contactName.trim()) {
this.showToast('请输入联系人姓名');
return false;
}

if (this.contactName.trim().length > 50) {
this.showToast('联系人姓名最多输入50个字', '18em');
return false;
}

if (!this.verifyPhone()) {
return false;
}

if (!this.verificationCode) {
this.showToast('请输入验证码');
return false;
}

return true;
},


verifyPhone() {
if (this.contactPhone.trim() === '') {
this.showToast('请输入手机号');
return false;
}
if (!/^(13|15|18|14|17)\d{9}$/.test(this.contactPhone)) {
this.showToast('手机号有误，请重新输入', '18em');
return false;
}
return true;
},


loginApp() {
if (this.verificationCode === '') {
this.showToast('验证码为空', '10em');
return;
}
this.isRequesting = true;
loginApp(
{
mobilePhone: this.contactPhone,
smsVerifyCode: this.verificationCode,
},
{
deviceid: this.deviceId,
},
).then((res) => {
this.isRequesting = false;
if (res.status !== 0) {
this.verificationCode = '';
this.showToast(res.msg, '15em');
return false;
}
const data = res.data || {};
this.deviceId = data.deviceId;
this.$store.dispatch('SET_USERPHONE', this.contactPhone);
this.saveInfo();
return true;
});
setTimeout(() => {
this.isRequesting = false;
}, 5000);
},


fetchVerificationCode() {
if (this.verifyPhone()) {
this.isSendCode = true;
this.countDown();
fetchVerificationCode(
{
mobilePhone: this.contactPhone,
verifyCodeType: 'MOBILE_LOGIN',
},
{
deviceid: this.deviceId,
},
).then((res) => {
if (res.status !== 0) {
this.showToast(res.msg, '18em');
return false;
}
return true;
});
}
},

saveInfo() {
saveFormData(
{
provinceCode: this.provinceId,
cityCode: this.cityId,
companyName: this.companyName,
personNum: this.personNum,
contactName: this.contactName,
contactPhone: this.contactPhone,
},
).then((res) => {
if (res.status !== 0) {
const msg = res.msg || '接口异常，请稍后重试';
this.verificationCode = '';
this.showToast(msg, '18em');
return false;
}
this.$router.push({
path: 'submitSuccess',
});
return true;
}).catch(() => {
this.verificationCode = '';
this.showToast('接口异常，请稍后重试', '18em');
});
},
},

mounted() {
Log('app.takeself.h5_application_detail');
this.clearInterval();
},
};



// WEBPACK FOOTER //
// ./src/pages/Application/components/Submit/main.js